export default "__VITE_ASSET__DTGAM45d__"